/**
 * A name for this browser, as distinct from this tab or this account.
 *
 * Two tabs of the same browser are two signalling sessions, but they share one library —
 * the same IndexedDB — so copying files between them is work that achieves nothing and
 * would double the apparent size of every share. They need to be able to recognise each
 * other, and neither the session name (per connection) nor the account (per person) does
 * that. This does.
 *
 * It identifies a browser profile and nothing else: no account, no device, no person. It
 * is only ever shown to other sessions of the same account, which is to say to the same
 * person.
 */

const KEY = '3dpreview:install';

export function installId(): string {
  const remembered = window.localStorage.getItem(KEY);
  if (remembered !== null && remembered.length > 0) return remembered;

  const fresh = generate();
  window.localStorage.setItem(KEY, fresh);
  return fresh;
}

function generate(): string {
  // randomUUID needs a secure context, which is also what WebRTC needs, so where sharing
  // works at all this is always available. The fallback keeps tests honest.
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return `install-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
